import { NewLogin } from "../Login";

function Login() {
  return <NewLogin />;
}

export default Login;
